import * as React from "react";
import { NavLink } from "react-router-dom";

/* eslint-disable import/no-webpack-loader-syntax */
// import AngleLeftIcon from "-!svg-react-loader!../../img/angle-left.svg";
// import AngleRightIcon from "-!svg-react-loader!../../img/angle-right.svg";
/* eslint-enable import/no-webpack-loader-syntax */

interface IProps {
  currentPage: number;
  pageSize: number;
  totalPages: number;
}

const Pager: React.SFC<IProps> = (props) => {
  const pageNums = [];

  if (props.totalPages < 8) {
    for (let i = 1; i <= props.totalPages; i++) {
      pageNums.push(i)  
    }
    // pageNums.push(...[...Array(props.totalPages).keys()].map(k => k + 1));
  } else {
    pageNums.push(1);

    if ((props.currentPage - 2 > 1) && (props.currentPage + 2 < props.totalPages)) {
      if (props.currentPage - 2 > 2) {
        pageNums.push(null);
      }

      pageNums.push(props.currentPage - 2);
      pageNums.push(props.currentPage - 1);
      pageNums.push(props.currentPage);
      pageNums.push(props.currentPage + 1);
      pageNums.push(props.currentPage + 2);

      if (props.currentPage + 2 <= props.totalPages - 2) {
        pageNums.push(null);
      }
    } else if (props.currentPage - 2 <= 1) {
      pageNums.push(2);
      pageNums.push(3);
      pageNums.push(4);
      pageNums.push(null);
    } else if (props.currentPage + 2 >= props.totalPages) {
      pageNums.push(null);
      pageNums.push(props.totalPages - 3);
      pageNums.push(props.totalPages - 2);
      pageNums.push(props.totalPages - 1);
    }

    pageNums.push(props.totalPages);
  }

  const PrevPage = () => {
    const page = props.currentPage - 1 < 1 ? 1 : props.currentPage - 1;
    return (
      <li>
        <NavLink to={`/report/page/${page}/pageSize/${props.pageSize}`}>
          <span className="glyphicon glyphicon-chevron-left" />
          {/* <AngleLeftIcon className="nav-icon" /> */}
        </NavLink>
      </li>
    );
  };

  const NextPage = () => {
    const page = props.currentPage + 1 > props.totalPages ? props.totalPages : props.currentPage + 1;
    return (
      <li>
        
        <NavLink to={`/report/page/${page}/pageSize/${props.pageSize}`}>
          <span className="glyphicon glyphicon-chevron-right" />
          {/* <AngleRightIcon className="nav-icon" /> */}
        </NavLink>
      </li>
    );
  };

  const getPageClass = (page: number | null, curPage: number): string => {
    if (page === null) {
      return "ellipsis";
    }

    if (page === curPage) {
      return "active";
    } else {
      return "";
    }
  };

  return (
    <div className="">
    {props.totalPages > 1 ? (
      <ul className="pagination">
        <PrevPage />
        {pageNums.map(p => (
          <li
            key={p !== null ? p : props.totalPages + 1 + Math.random() * 10000}
            className={getPageClass(p, props.currentPage)}
          >
            {p !== null ? (
              <NavLink to={`/report/page/${p}/pageSize/${props.pageSize}`}>{p}</NavLink>
            ) : (
              <span>...</span>
            )}
          </li>
        ))}
        <NextPage />
      </ul>
    ) : (
      ""
    )}
    </div>
  );
}

export default Pager


// WEBPACK FOOTER //
// ./src/components/Pager/Pager.tsx